import React, { useState } from "react";

import Grouping from "../../point/Grouping";
import { TAKS_IMPORT } from "../../../config/lang";
import { translate } from "../../../util/util";

export default function GroupingAction({ checked, rows, currentUser, onDone }) {
  const [open, setOpen] = useState(false);
  const [clearPointsTrigger, setClearPointsTrigger] = useState(0);

  const checkedRowsIds = checked;

  const handleGroupPopup = () => {
    setOpen(prev => {
      const next = !prev;
      if (!next) {
        // popup closed: reset and let the table refresh
        setClearPointsTrigger(t => t + 1);
        if (onDone) onDone();
      }
      return next;
    });
  };

  const getCurrentGroupData = () => {};

  return (
    <>
      <button
        className="mp-toggle-btn pt-bulk-btn"
        disabled={checked.length === 0}
        onClick={handleGroupPopup}>
        <span className="material-symbols-outlined">workspaces</span>
        {translate(TAKS_IMPORT, "grouping_btn_name", currentUser.language)}
      </button>
      <Grouping
        isActive={open}
        handleGroupPopup={handleGroupPopup}
        checkedRowsIds={checkedRowsIds}
        getCurrentGroupData={getCurrentGroupData}
        filterUrlKeys={{}}
        onAllPointsAdded={() => {}}
        clearPointsTrigger={clearPointsTrigger}
      />
    </>
  );
}
